<template>
    <div>
        <v-data-table
            :items="desserts"
            :headers="headers"
            hide-default-footer
        >
            <template v-slot:[`item.Btn`]="{ item }">
                <v-btn
                    :disabled="btn[3].isActive"
                    color="green darken-4"
                    text
                    @click="editModal(item)">変更</v-btn>
            </template>
        </v-data-table>
        <PointTypeModal ref="Modal" :edit-info="findData" @refresh-event="getPointType"></PointTypeModal>
    </div>
</template>

<script>
import { GET_POINT_TYPE } from '../../../constants/master';
import PointTypeModal from './modal/PointTypeModal';
import { MasterPagesMixin } from './mixin/MasterPagesMixin.js';
import { authorityMixin } from '@/views/authorityMixin';

export default {
    components: {
        PointTypeModal
    },
    // マスタ管理の共通項目をMixinする ./mixin/MasterPagesMixin.js
    mixins: [
        authorityMixin,
        MasterPagesMixin
    ],
    data () {
        return {
            // ヘッダー
            headers: [
                { text: 'コード', value: 'point_type', sortable: false, align: 'center' },
                { text: 'コード名', value: 'point_type_name', sortable: false },
                { text: '表示名', value: 'point_type_display', sortable: false },
                { text: '詳細内容', value: 'detail', class: 'detailWidth', sortable: false },
                { text: '', value: 'Btn', sortable: false }
            ],
            // ボタンの活性・非活性
            btn: [
                { element_id: '000', element_name: '画面', isActive: true },
                { element_id: '001', element_name: '参照', isActive: true },
                { element_id: '002', element_name: '追加', isActive: true },
                { element_id: '003', element_name: '変更', isActive: true },
                { element_id: '004', element_name: '削除', isActive: true }
            ],
            vue_id: 'SCR0010'
        };
    },
    created () {
        this.initialize();
    },
    methods: {
        /** ----------------------------------------------
         * 初期表示時処理
         * ---------------------------------------------- */
        async initialize () {
            this.admin = await this.getLoginAdmin();
            this.getAuthorityList();
            this.getPointType();
        },
        /** --------------------------------------------
        * ポイント区分情報を取得
        * -------------------------------------------- */
        async getPointType () {
            this.desserts = await this.$apollo.mutate({ mutation: GET_POINT_TYPE })
                .then(res => { return res.data.getPointType; })
                .catch(e => { this.error = e; });
        },
        /** --------------------------------------------
        * モーダル画面を表示 './modal/PointTypeModal.vue'
        * -------------------------------------------- */
        editModal (item) {
            this.findData = this.desserts.find(ele => ele.id === item.id);
            this.$refs.Modal.ChangeModal(true);
        }
    }
};
</script>

<style scoped>

.v-data-table ::v-deep td{
    max-width: 400px;
}
</style>
